
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mainStore, companyStore } from '@/store';
import ShowPopup from '@/components/ShowPopup.vue';
import _ from 'lodash';
import AprovarPontoAcompanhamento from './AprovarPontoAcompanhamento.vue';

@Component({
  components: {
    ShowPopup,
    AprovarPontoAcompanhamento,
  },
})
export default class ListAprovarPonto extends Vue {
  @Watch('propState', { immediate: true, deep: true })
  async buscaInfo(val) {
    if (val > 0) {
      this.company_files = await companyStore.getCompanyPontoAcompanhamentoBlobs(this.tableName);
    }
  }
  public isLoading = false;
  public company_files = [];
  public tipoUploadAcompanhamento = '';
  public tableName = '';
  public propState = 0;
  public itemParm = [];

  public header = [
    {
      text: 'Nome do Arquivo',
      value: 'blob.name',
      align: 'left',
    },
    {
      text: 'Tamanho do arquivo',
      value: 'blob.size',
      align: 'left',
    },
    {
      text: 'Criado em',
      value: 'blob.created',
      align: 'left',
    },
    {
      text: 'Status',
      value: 'status_arquivo',
      align: 'left',
    },
    {
      text: 'Ações',
      value: 'actions',
      align: 'left',
    },
  ];

  get currentUser() {
    return mainStore.userProfile;
  }

  public formatSize(size) {
    if (size < 1000) {
      return `${(size / 1).toFixed(0)} B`;
    } else if (size / Math.pow(10, 3) < 1000) {
      return `${(size / Math.pow(10, 3)).toFixed(2)} Kb`;
    } else if (size / Math.pow(10, 6) < 1000) {
      return `${(size / Math.pow(10, 6)).toFixed(2)} Mb`;
    } else if (size / Math.pow(10, 9) < 1000) {
      return `${(size / Math.pow(10, 9)).toFixed(2)} Gb`;
    }
  }

  public handleAprovarAcompanhamento(item: any) {
    this.propState = 0;
    this.itemParm = item;
    let form: any = this.$refs.showFiles;
    form.show();
  }

  public async mounted() {
    this.isLoading = true;
    const params = this.$route.params;

    const tablename = _.get(params, 'tablename');
    const tipo_upload = _.get(params, 'tipo_upload');

    this.tipoUploadAcompanhamento = tipo_upload;
    this.tableName = tablename;

    this.company_files = await companyStore.getCompanyPontoAcompanhamentoBlobs(this.tableName);

    this.isLoading = false;
  }
}
